import { CanActivateFn } from '@angular/router';
import { UserModel } from '@models/user.model';
import { createRoleGuard } from './role-guard.utils';

export const userRoleGuard: CanActivateFn = () =>
  createRoleGuard({
    allowedRole: UserModel.Role.USER,
    redirectByRole: {
      [UserModel.Role.OPERATOR]: UserModel.Role.OPERATOR,
    },
    fallbackRedirectRole: UserModel.Role.DEVELOPER,
  });
